import axiosHandler from "interceptor/axiosInterceptor";

export const getRole = async () => {
  try {
    const response = await axiosHandler.get("/role/details");
    return response;
  } catch (error) {
    throw error;
  }
};

export const addRole = async (data) => {
  try {
    const response = await axiosHandler.post("/role/add", data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateRole = async (data, roleId) => {
  try {
    const response = await axiosHandler.put(`/role/edit/${roleId}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteRole = async (roleId, isActive) => {
  try {
    const response = await axiosHandler.put(`/role/delete/${roleId}`, isActive);
    return response;
  } catch (error) {
    throw error;
  }
};
